<template>
    <section>
        <div class="container">
            <h2>
                ページが見つかりません
            </h2>
            <p>
                このURLは存在しません。
            </p>
        </div>
    </section>
</template>

<script>
    export default {
        title:'Not Found',
        description: ''
    }
</script>


// WEBPACK FOOTER //
// src/components/PageNotFound.vue